
import i18n from '@/plugins/i18n'
export default {
  browse:{
    table:{
      headers: [
        {
          text:  i18n.t("model.prop.no"),
          value: 'index',
          sortable: false,
          filterable: false,
        },
        {
          text: 'Mochi Id',
          value: 'mochiId',
        },
        {
          text: 'Award Count',
          value: 'awardCount',
        },
        {
          text: 'Dawing',
          value: 'drawing',
        },
      ],
    },
  },
  read: false,
  add:false,
  edit:true,
  delete:true,
}